module.exports = __webpack_public_path__ + "img/data_overview_map_flag.a7df9cd5.png";